<template>
  <div class="my-rendered-content" v-html="content"></div>
</template>

<script>
export default {
  name: 'QuillContent',
  props: {
    content: {
      type: String,
      required: true
    }
  }
}
</script>
